<template>
    <div class="infoengine relationship-section">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-4 filter-title-section">
                    <h2>Investment Range Factor</h2>
                </div>

                <div class="col-md-2">
                    <b-form-group
                            id="input-group-4"

                    >
                        <b-form-select name="DataSegment" v-validate="{ required: true }" v-model="dataSegmentIdToFetch" :options="dataSegmentOptions"></b-form-select>
                    </b-form-group>
                </div>

                <div class="col-md-2">
                    <base-search
                            placeholder="Search"
                            @keyword="getKeyword"
                    ></base-search>
                </div>

                <div class="col-md-1">
                    <button
                            class="btn btn-primary"
                            type="submit"
                            :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        "
                            @click="apply"
                    >
                        <span class="btn-text">Apply</span>
                        <span class="loader"></span>
                    </button>
                </div>
                <div class="col-md-2">
                    <b-button
                            type="button"
                            variant="secondary"
                            class="secondary-add-btn"
                            @click="
                                            $bvModal.show(
                                                'add-investment-popup'
                                            )
                                        "
                    >
                                        <span class="btn-text"
                                        >+ Add Investment Range</span
                                        >
                    </b-button>
                </div>

                <div class="col-md-1">
                    <button
                            class="btn btn-primary"
                            type="button"
                            :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        "
                            @click="$bvModal.show(
                                                'set-currency-popup'
                                            )"
                    >
                        <span class="btn-text">Currency</span>
                    </button>
                </div>


            </div>
        </div>

        <div
            :class="[
                'table-section',
                'tablet-table-xxs-min-width',

                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <b-table :items="data" :fields="fields">
                <template slot="investmentRange" slot-scope="data">
                    <span>{{data.value.minimum}} to </span>

                    <span>{{ data.value.maximum }}</span>
                </template>
                <template slot="status" slot-scope="data">
                    <div class="action-review">
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-investment-popup')
                            "
                        ></base-action>
                        <!-- if action archive -->
                        <base-action
                            :icon="
                                data.value == 'active'
                                    ? 'icon-trash'
                                    : 'icon-done'
                            "
                            :label="
                                data.value == 'active' ? 'Archive' : 'Activate'
                            "
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('status-update-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
        </div>
        <!-- Get list records -->
        <base-records
            path="configurations/investments-range"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>
        <!-- Add investment popup -->
        <add-investment-popup
            :title="title"
            :button-text="buttonText"
        ></add-investment-popup>

        <set-currency-popup :dataSegmentId="dataSegmentIdToFetch" :currency="currency"></set-currency-popup>
        <!-- Archive popup -->
        <archive-popup
            title="Archive Investment Range Factor"
            description="Are you sure you want to archive this investment range factor? You can re-activate it later."
        ></archive-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import addInvestmentPopup from '@/components/popups/AddInvestmentPopup.vue'
import SetCurrencyPopup from '@/components/popups/SetCurrencyPopup.vue'
import archivePopup from '@/components/popups/ArchivePopup.vue'
import Resource from '@/api/resource'
const apiResource = new Resource('configurations/get-all-dataSegments/')
export default {
    components: {
        addInvestmentPopup,
        archivePopup,
        SetCurrencyPopup
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            dataSegmentIdToFetch:'',
            currency:'',
            dataSegmentOptions: [],
            fields: [
                {
                    key: 'investmentRange',
                    label: 'Investment Range',
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'ACTION',
                    class: 'two-list w-300px text-center',
                },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'investmentRange',
                sortOrder: 'asc',
            },
            reset: new Date().getTime(),
            title: '',
            buttonText: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'showPageLoader', 'loading','dataSegmentId']),
    }, // End of Component > methods
     /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        async dataSegmentIdToFetch(value){
           await this.apply()
            await this.getRolesList()
        },
        currency(value)
        {
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getRolesList();
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getRolesList(){
            const result = await apiResource.list();
            if(result && result.data){
                let tempDataSegments= result.data.data.map(el => ({value: el._id, text: el.title}));
                tempDataSegments= [{value: '', text: 'All DataSegments'} , ...tempDataSegments]
                this.dataSegmentOptions = tempDataSegments;

                let fetchSelected = result.data.data.map(el => {
                    if (this.dataSegmentIdToFetch!='' && el._id==this.dataSegmentIdToFetch) {
                        return el;
                    }
                    else if(this.dataSegmentIdToFetch=='' && el._id==this.dataSegmentId)
                    {
                        return el;
                    }
                });
                fetchSelected = fetchSelected.filter(el => el !== undefined && el !== null);
                this.currency = fetchSelected[0].currency

            }

        },
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        apply() {
            this.$store.commit('setLoading', true)
            this.query.dataSegmentId = this.dataSegmentIdToFetch
            this.reset = new Date().getTime()
        }, // End of apply() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method
    }, // End of Component > mounted
} // End of export default
</script>
